export default __webpack_public_path__ + "static/media/Kafka.b82a79f6.png";